<script> 
	// Stores 
	import { textSite, mailLocacao } from '../store.js';    
	import { afterUpdate } from 'svelte';     

	// Componentes
	import { Router, Link, link , Route }   from "svelte-routing";
	import PageHeader                       from "../components/PageHeader.svelte";
	import Forms                            from "../components/Forms.svelte";  

	// Code
	let titlePage = 'Ficha cadastral para Locatário';

	const estados = [{title:'RS',value:'RS'},{title:'AC',value:'AC'},{title:'AL',value:'AL'},{title:'AP',value:'AP'},{title:'AM',value:'AM'},{title:'BA',value:'BA'},{title:'CE',value:'CE'},{title:'DF',value:'DF'},{title:'ES',value:'ES'},{title:'GO',value:'GO'},{title:'MA',value:'MA'},{title:'MT',value:'MT'},{title:'MS',value:'MS'},{title:'MG',value:'MG'},{title:'PA',value:'PA'},{title:'PB',value:'PB'},{title:'PR',value:'PR'},{title:'PE',value:'PE'},{title:'PI',value:'PI'},{title:'RJ',value:'RJ'},{title:'RN',value:'RN'},{title:'RO',value:'RO'},{title:'RR',value:'RR'},{title:'SC',value:'SC'},{title:'SP',value:'SP'},{title:'SE',value:'SE'},{title:'TO',value:'TO'}];
	const estadoCivil = [{title:'Solteiro(a)',value:'Solteiro(a)'},{title:'Casado(a)',value:'Casado(a)'},{title:'Separado(a)',value:'Separado(a)'},{title:'Desquitado(a)',value:'Desquitado(a)'},{title:'Divorciado(a)',value:'Divorciado(a)'},{title:'Viúvo(a)',value:'Viúvo(a)'},{title:'Amasiado(a)',value:'Amasiado(a)'},{title:'Outros',value:'Outros'}];
	let fields = [
		{
			name: 'end-peretendido',
			title: 'Endereço do imóvel peretendido *',
			required: 'required',
		},
		{
			name: 'aluguel-pretendido',
			title: 'Aluguel R$ *',
			required: 'required',
			rowclass: 'w-25',
			classe: 'mask-number'
		},
		{
			name: 'condominio-pretendido',
			title: 'Condomínio *',
			required: 'required',
			rowclass: 'w-25',
			classe: 'mask-number'
		},
		{
			name: 'iptu-pretendido',
			title: 'IPTU R$ *',
			required: 'required',
			rowclass: 'w-25',
			classe: 'mask-number'
		},
		{
			name: 'total-pretendido',
			title: 'Total R$ *',
			required: 'required',
			rowclass: 'w-25',
			classe: 'mask-number'
		},
		{
			name: 'razao-social',
			title: 'Razão Social *',
			required: 'required',
		},
		{
			name: 'nome',
			title: 'Nome Fantasia *',
			required: 'required',
		},
		{
			name: 'end-rua',
			title: 'End. da sede Rua/Av. *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'email',
			title: 'E-mail *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'end-bairro',
			title: 'Bairro *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'telefone',
			title: 'Telefone *',
			required: 'required',
			classe: 'mask-telefone',
			rowclass: 'w-50'
		},
		{
			name: 'end-cidade',
			title: 'Cidade *',
			required: 'required',
			rowclass: 'w-40'
		},
		{
			name: 'estado',
			title: 'Estado *',
			required: 'required',
			rowclass: 'w-20',
			type: 'select',
			selectValues: estados
		},
		{
			name: 'cep',
			title: 'Cep *',
			required: 'required',
			rowclass: 'w-40',
		},
		{
			name: 'dt-fundacao',
			title: 'Data da Fundação *',
			required: 'required',
			rowclass: 'w-25',
			classe: 'mask-data'
		},
		{
			name: 'ins-estadual',
			title: 'Inscrição Estadual *',
			required: 'required',
			rowclass: 'w-25',
		},
		{
			name: 'contato-estatuto',
			title: 'Contrato ou Estatutos de constituição sob nº *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'orgao-registro',
			title: 'Nome do órgão competente em que está registrada *',
			required: 'required',
		},
		{
			name: 'capital-registro',
			title: 'Capital (Atual) registrado R$ *',
			required: 'required',
			rowclass: 'w-50',
			classe: 'mask-number'
		},
		{
			name: 'valor-emGiro',
			title: 'Em giro R$ *',
			required: 'required',
			rowclass: 'w-50',
			classe: 'mask-number'
		},
		{
			name: 'valor-faturamentoMensal',
			title: 'Faturamento Mensal R$ *',
			required: 'required',
			rowclass: 'w-50',
			classe: 'mask-number'
		},
		{
			name: 'valor-imobilizadoAtual',
			title: 'Imobilizado (Valor) R$ *',
			required: 'required',
			rowclass: 'w-50',
			classe: 'mask-number'
		},
		{
			name: 'numero-empregados',
			title: 'Nº de empregados *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'folha-pagamento',
			title: 'Folha de pagamento R$',
			rowclass: 'w-50',
			classe: 'mask-number'
		},
		{
			title: 'Principais acionistas/sócios ou titulares/diretores ou sócios gerentes (nome e cpf)',
			type: 'separator'
		},
		{
			name: 'acionista-nome',
			title: 'Nome *',
			required: 'required',
			rowclass: 'w-70',
		},
		{
			name: 'acionista-cpf',
			title: 'CPF *',
			required: 'required',
			classe: 'mask-cpf',
			rowclass: 'w-30',
		},
		{
			name: 'acionista2-nome',
			title: 'Nome',
			rowclass: 'w-70',
		},
		{
			name: 'acionista2-cpf',
			title: 'CPF',
			classe: 'mask-cpf',
			rowclass: 'w-30',
		},
		{
			name: 'acionista3-nome',
			title: 'Nome',
			rowclass: 'w-70',
		},
		{
			name: 'acionista3-cpf',
			title: 'CPF',
			classe: 'mask-cpf',
			rowclass: 'w-30',
		},
		{
			title: 'Preferências bancárias (Banco e Agência)',
			type: 'separator'
		},
		{
			name: 'preferencia-bancoNome',
			title: 'Nome *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'preferencia2-bancoAgencia',
			title: 'Banco *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'preferencia2-bancoNome',
			title: 'Nome',
			rowclass: 'w-50',
		},
		{
			name: 'preferencia3-bancoAgencia',
			title: 'Banco',
			rowclass: 'w-50',
		},
		{
			name: 'preferencia3-bancoNome',
			title: 'Nome',
			rowclass: 'w-50',
		},
		{
			name: 'preferencia-bancoAgencia',
			title: 'Banco',
			rowclass: 'w-50',
		},
		{
			title: 'Principais Fornecedores (Nome e Endereço)',
			type: 'separator'
		},
		{
			name: 'fornecedor-nome',
			title: 'Nome *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'fornecedor-endereco',
			title: 'Endereço *',
			required: 'required',
			rowclass: 'w-50',
		},
		{
			name: 'fornecedor2-nome',
			title: 'Nome',
			rowclass: 'w-50',
		},
		{
			name: 'fornecedor2-endereco',
			title: 'Endereço',
			rowclass: 'w-50',
		},
		{
			name: 'fornecedor3-nome',
			title: 'Nome',
			rowclass: 'w-50',
		},
		{
			name: 'fornecedor3-endereco',
			title: 'Endereço',
			rowclass: 'w-50',
		},
	];

	const message = `Ficha Cadastral Locatário | Pessoa Jurídica - Enviado pelo Site
<hr>
<p><b>Endereço do imóvel peretendido:</b> {end-peretendido}</p>
<p><b>Aluguel R$:</b> {aluguel-pretendido}</p>
<p><b>Condomínio R$:</b> {condominio-pretendido}</p>
<p><b>IPTU R$:</b> {iptu-pretendido}</p>
<p><b>Total R$:</b> {total-pretendido}</p>
<p><b>Razão Social:</b> {razao-social}</p>
<p><b>Nome Fantasia:</b> {nome}</p>
<p><b>End. da sede Rua/Av.:</b> {end-rua}</p>
<p><b>E-mail:</b> {nome}</p>
<p><b>Bairro:</b> {end-bairro}</p>
<p><b>Telefone:</b> {telefone}</p>
<p><b>Cidade:</b> {end-cidade}</p>
<p><b>Estado:</b> {estado}</p>
<p><b>Cep:</b> {cep}</p>
<p><b>Data da Fundação:</b> {dt-fundacao}</p>
<p><b>Inscrição Estadual:</b> {ins-estadual}</p>
<p><b>Contrato ou Estatutos de constituição sob nº:</b> {contato-estatuto}</p>
<p><b>Nome do órgão competente em que está registrada:</b> {orgao-registro}</p>
<p><b>Capital(atual) registrado R$:</b> {capital-registro}</p>
<p><b>Em giro R$:</b> {valor-emGiro}</p>
<p><b>Faturamento Mensal R$:</b> {valor-faturamentoMensal}</p>
<p><b>Imobilizado(Valor) R$:</b> {valor-imobilizadoAtual}</p>
<p><b>Nº de empregados:</b> {numero-empregados}</p>
<p><b>Foolha de pagamento(Valor) R$:</b> {folha-pagamento}</p>
<br>
<h2><b>PRINCIPAIS ACIONISTAS/SÓCIOS OU TITULARES/DIRETORES OU SÓCIOS GERENTES</b></h2>
<p><b>ACIONISTA 1</b>}</p>
<p><b>Nome:</b> {acionista-nome}</p>
<p><b>CPF:</b> {acionista-cpf}</p>
<p><b>ACIONISTA 2</b>}</p>
<p><b>Nome:</b> {acionista2-nome}</p>
<p><b>CPF:</b> {acionista2-cpf}</p>
<p><b>ACIONISTA 3</b>}</p>
<p><b>Nome:</b> {acionista3-nome}</p>
<p><b>CPF:</b> {acionista3-cpf}</p>
<br>
<h2><b>REFERÊNCIAS BANCÁRIAS</b></h2>
<p><b>REFERÊNCIA BANCÁRIA 1</b>}</p>
<p><b>Nome:</b> {preferencia-bancoNome}</p>
<p><b>Banco:</b> {preferencia2-bancoAgencia}</p>
<p><b>REFERÊNCIA BANCÁRIA 2</b>}</p>
<p><b>Nome:</b> {preferencia2-bancoNome}</p>
<p><b>Banco:</b> {preferencia3-bancoAgencia}</p>
<p><b>REFERÊNCIA BANCÁRIA 3</b>}</p>
<p><b>Nome:</b> {preferencia3-bancoNome}</p>
<p><b>Banco:</b> {preferencia-bancoAgencia}</p>
<br>
<h2><b>PRINCIPAIS FORNECEDORES</b></h2>
<p><b>FORNECEDOR 1</b>}</p>
<p><b>Nome:</b> {fornecedor-nome}</p>
<p><b>Endereço:</b> {fornecedor-endereco}</p>
<p><b>FORNECEDOR 2</b>}</p>
<p><b>Nome:</b> {fornecedor2-nome}</p>
<p><b>Endereço:</b> {fornecedor2-endereco}</p>
<p><b>FORNECEDOR 3</b>}</p>
<p><b>Nome:</b> {fornecedor3-nome}</p>
<p><b>Endereço:</b> {fornecedor3-endereco}</p>
<hr>
<p><b>$info</b>}</p>`;

	let loading = false;
	function send() {
		loading = true;
	}    

	let destiny = $mailLocacao;
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>
<div class="container">
	<p class="text-center">
		Pessoa Jurídica
	</p>
	<div class="offset-md-1 col-md-10 pl-0 pr-0">        
		<hr class="line-separator">
		<Forms fields={fields} destiny={destiny} subjectTitle="{titlePage}" {message} htmlbody={true} />
	</div>
</div>